import clsx from "clsx";

import { Icon } from "../base/Icon";
import { useAuth } from "../../hooks/useAuth";

type AdminCanaryRoutingToggleProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

/**
 * Admin-only icon button: when ON, the debugger's next WebSocket session
 * routes to the canary (inactive) color of the blue/green deploy instead
 * of the active color real traffic hits. Renders nothing for non-admins.
 *
 * State is owned by the parent debugger wrapper and resets to false on every
 * mount — explicit per-session opt-in. Toggling does not tear down a live
 * session; the value is captured at session start.
 */
export const AdminCanaryRoutingToggle = ({ value, onChange }: AdminCanaryRoutingToggleProps) => {
  const { isAdmin } = useAuth();

  if (!isAdmin) return null;

  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      title={
        value
          ? "Session pinned to the canary (inactive) color. Click to pin to the active color."
          : "Session pinned to the active color. Click to pin to the canary (inactive) color and validate a canary build before promote."
      }
      className={clsx(
        "flex items-center justify-center h-9 w-9 rounded-lg transition-colors flex-shrink-0 border",
        value
          ? "bg-purple-50 dark:bg-purple-950/40 text-purple-600 dark:text-purple-400 border-purple-200 dark:border-purple-800 hover:bg-purple-100 dark:hover:bg-purple-900/50"
          : "bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700",
      )}
    >
      <Icon
        name="alt-route"
        size={16}
      />
    </button>
  );
};
